import { useState, useCallback } from 'react';

export function useNotification() {
  const [notification, setNotification] = useState({ show: false, message: '', type: 'info' });

  const showNotification = useCallback((message, type = 'info', duration = 4000) => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification({ show: false, message: '', type: 'info' });
    }, duration);
  }, []);

  const hideNotification = useCallback(() => {
    setNotification({ show: false, message: '', type: 'info' });
  }, []);

  return {
    notification,
    showNotification,
    hideNotification,
  };
}